// ── SMART Valuation Model ──────────────────────────────────────────────────────
// 19 attributi SMART aggregati da 58 FULL parameters.
// Pesi per ruolo (ATT/CC/DIF sommano 100 ciascuno).
// 7 playstyle con pesi. Radar 5 aree.

// ── 19 SMART Parameters ───────────────────────────────────────────────────────

export const SMART_PARAMS = [
	{id: "decision_making", label: "Decision making", category: "Mental"},
	{id: "concentration", label: "Concentrazione", category: "Mental"},
	{id: "mentality", label: "Mentalita", category: "Mental"},
	{id: "team_play", label: "Team play", category: "Mental"},
	{id: "control", label: "Controllo", category: "Technical"},
	{id: "passing", label: "Passaggio", category: "Technical"},
	{id: "dribbling", label: "Dribbling", category: "Technical"},
	{id: "finishing", label: "Finalizzazione", category: "Technical"},
	{id: "speed", label: "Velocita", category: "Physical"},
	{id: "explosiveness", label: "Esplosivita", category: "Physical"},
	{id: "stamina", label: "Resistenza", category: "Physical"},
	{id: "strength", label: "Forza", category: "Physical"},
	{id: "positioning", label: "Posizionamento", category: "Tactical"},
	{id: "game_reading", label: "Lettura gioco", category: "Tactical"},
	{id: "off_ball_movement", label: "Movimento senza palla", category: "Tactical"},
	{id: "vision", label: "Visione", category: "Tactical"},
	{id: "offensive_duels", label: "Duelli offensivi", category: "Duels"},
	{id: "defensive_duels", label: "Duelli difensivi", category: "Duels"},
	{id: "aerial_duels", label: "Duelli aerei", category: "Duels"},
];

export const SMART_CATEGORIES = [
	{id: "Mental", label: "Mentale", color: "#7c3aed"},
	{id: "Technical", label: "Tecnica", color: "#2563eb"},
	{id: "Physical", label: "Fisico", color: "#16a34a"},
	{id: "Tactical", label: "Tattica", color: "#d97706"},
	{id: "Duels", label: "Duelli", color: "#dc2626"},
];

// ── Role Weights (sommano 100 per ruolo) ──────────────────────────────────────

export const ROLE_WEIGHTS = {
	ATT: {
		decision_making: 5, concentration: 3, mentality: 4, team_play: 3,
		control: 6, passing: 5, dribbling: 7, finishing: 12,
		speed: 6, explosiveness: 6, stamina: 3, strength: 5,
		positioning: 5, game_reading: 3, off_ball_movement: 8, vision: 4,
		offensive_duels: 8, defensive_duels: 2, aerial_duels: 5,
	},
	CC: {
		decision_making: 6, concentration: 4, mentality: 5, team_play: 5,
		control: 7, passing: 10, dribbling: 5, finishing: 8,
		speed: 4, explosiveness: 4, stamina: 7, strength: 5,
		positioning: 6, game_reading: 7, off_ball_movement: 5, vision: 7,
		offensive_duels: 2, defensive_duels: 2, aerial_duels: 1,
	},
	DIF: {
		decision_making: 5, concentration: 6, mentality: 5, team_play: 4,
		control: 4, passing: 5, dribbling: 1, finishing: 5,
		speed: 6, explosiveness: 5, stamina: 5, strength: 9,
		positioning: 8, game_reading: 8, off_ball_movement: 3, vision: 6,
		offensive_duels: 2, defensive_duels: 8, aerial_duels: 5,
	},
};

export const ROLE_LABELS = {ATT: "Attaccante", CC: "Centrocampista", DIF: "Difensore"};

// ── Playstyles ────────────────────────────────────────────────────────────────

export const PLAYSTYLES = [
	{
		id: "finisher",
		label: "Finisher",
		emoji: "🎯",
		weights: {finishing: 0.3, off_ball_movement: 0.25, positioning: 0.2, decision_making: 0.15, offensive_duels: 0.1},
	},
	{
		id: "creator",
		label: "Creator",
		emoji: "🎨",
		weights: {vision: 0.3, passing: 0.3, control: 0.2, decision_making: 0.2},
	},
	{
		id: "ball_winner",
		label: "Ball Winner",
		emoji: "🛡",
		weights: {defensive_duels: 0.3, game_reading: 0.25, strength: 0.2, stamina: 0.15, concentration: 0.1},
	},
	{
		id: "box_to_box",
		label: "Box to Box",
		emoji: "🔄",
		weights: {stamina: 0.3, off_ball_movement: 0.2, team_play: 0.2, defensive_duels: 0.15, offensive_duels: 0.15},
	},
	{
		id: "explosive_winger",
		label: "Explosive Winger",
		emoji: "⚡",
		weights: {speed: 0.25, dribbling: 0.25, explosiveness: 0.25, off_ball_movement: 0.15, control: 0.1},
	},
	{
		id: "target_man",
		label: "Target Man",
		emoji: "💪",
		weights: {strength: 0.3, aerial_duels: 0.3, offensive_duels: 0.2, finishing: 0.2},
	},
	{
		id: "deep_playmaker",
		label: "Deep Playmaker",
		emoji: "🧠",
		weights: {vision: 0.3, passing: 0.3, game_reading: 0.2, decision_making: 0.2},
	},
	{
		id: "defender",
		label: "Difensore puro",
		emoji: "🧱",
		weights: {defensive_duels: 0.3, positioning: 0.25, game_reading: 0.25, strength: 0.2},
	},
];

// ── Radar areas (5 aree) ──────────────────────────────────────────────────────

export const RADAR_AREAS = [
	{id: "Mental", label: "Mentale", params: ["decision_making", "concentration", "mentality", "team_play"]},
	{id: "Technical", label: "Tecnica", params: ["control", "passing", "dribbling", "finishing"]},
	{id: "Physical", label: "Fisico", params: ["speed", "explosiveness", "stamina", "strength"]},
	{id: "Tactical", label: "Tattica", params: ["positioning", "game_reading", "off_ball_movement", "vision"]},
	{id: "Duels", label: "Duelli", params: ["offensive_duels", "defensive_duels", "aerial_duels"]},
];

// ── Compute functions ─────────────────────────────────────────────────────────

export function computeSmartOverall(values, role = "CC") {
	const weights = ROLE_WEIGHTS[role];
	if (!weights || !values) return 0;

	let total = 0;
	let weightSum = 0;

	SMART_PARAMS.forEach((param) => {
		const val = parseFloat(values[param.id]);
		const weight = weights[param.id] || 0;
		if (!isNaN(val) && weight > 0) {
			total += val * weight;
			weightSum += weight;
		}
	});

	return weightSum > 0 ? Math.round(total / weightSum) : 0;
}

export function computeAllOveralls(values) {
	return {
		ATT: computeSmartOverall(values, "ATT"),
		CC: computeSmartOverall(values, "CC"),
		DIF: computeSmartOverall(values, "DIF"),
	};
}

export function computePlaystyles(values) {
	if (!values) return [];

	return PLAYSTYLES.map((ps) => {
		let score = 0;
		Object.entries(ps.weights).forEach(([paramId, weight]) => {
			const val = parseFloat(values[paramId]);
			if (!isNaN(val)) {
				score += val * weight;
			}
		});
		return {
			id: ps.id,
			label: ps.label,
			emoji: ps.emoji,
			score: Math.round(score),
		};
	}).sort((a, b) => b.score - a.score);
}

export function computeRadarAreas(values) {
	if (!values) return [];

	return RADAR_AREAS.map((area) => {
		const vals = area.params
			.map((pid) => parseFloat(values[pid]))
			.filter((v) => !isNaN(v));
		const avg = vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : 0;
		return {
			area: area.label,
			value: Math.round(avg),
			fullMark: 100,
		};
	});
}

// ── Field key mapping (per salvataggio API) ───────────────────────────────────

export function valuesToApiFields(values) {
	const fields = {};
	SMART_PARAMS.forEach((p) => {
		const key = "smart" + p.id.charAt(0).toUpperCase() + p.id.slice(1).replace(/_([a-z])/g, (_, c) => c.toUpperCase());
		fields[key] = values[p.id] ?? null;
	});
	return fields;
}

export function apiFieldsToValues(data) {
	const values = {};
	SMART_PARAMS.forEach((p) => {
		const key = "smart" + p.id.charAt(0).toUpperCase() + p.id.slice(1).replace(/_([a-z])/g, (_, c) => c.toUpperCase());
		values[p.id] = data?.[key] ?? null;
	});
	return values;
}
